import getDeviceInfo from '@/lib/base/getDeviceInfo';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

export default [
  {
    path: '/personal',
    name: 'personal',
    component: () => import('@/views/Personal/PersonalRewrite.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      depth: 1,
    },
  },
  {
    path: '/personal/edit',
    name: 'personal-edit',
    component: () => import('@/views/Personal/InfoEdit.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/personal/edit/avatar',
    name: 'avatar',
    component: () => import('@/views/Personal/Avatar.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/personal/rank-intro',
    name: 'rank-intro',
    component: () => import('@/views/Personal/RankIntro.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/personal/setting',
    name: 'setting',
    component: () => import('@/views/Personal/Setting.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      transitionDepth: 2,
    },
  },
  {
    path: '/personal/setting/password',
    name: 'password',
    component: () => import('@/views/Personal/Password.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      transitionDepth: 3,
    },
  },

  {
    path: '/personal/setting/bindEmail',
    name: 'bindEmail',
    component: () => import('@/views/Personal/BindEmail.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      transitionDepth: 3,
    },
  },

  {
    path: '/personal/setting/bindStatus',
    name: 'bindStatus',
    component: () => import('@/views/Personal/BindStatus.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      transitionDepth: 3,
    },
  },

  {
    path: '/personal/setting/removeAccount',
    name: 'removeAccount',
    component: () => import('@/views/Personal/RemoveAccount.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/personal/exchange-course-code',
    name: 'exchange-course-code',
    component: () => import('@/views/Personal/ExchangeCourseCode.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/personal/exchange-course-confirm',
    name: 'exchange-course-confirm',
    component: () => import('@/views/Personal/ExchangeCourseConfirm.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/personal/exchange-success',
    name: 'exchange-success',
    component: () => import('@/views/Personal/ExchangeCourseResult.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/personal/language',
    name: 'language',
    component: () => import('@/views/Personal/Language.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      requireDesktop: true,
    },
  },
];
